"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable dot-notation */
const react_1 = __importDefault(require("react"));
const Chip_module_scss_1 = __importDefault(require("./Chip.module.scss"));
function Chip({ id, label, value, active = false, onClick = () => {
    /* do nothing */
}, }) {
    const clickHandler = () => {
        onClick(value);
    };
    return (
    // eslint-disable-next-line react/button-has-type
    react_1.default.createElement("button", { "data-active": active, className: Chip_module_scss_1.default['chip'], key: `${label}${id}`, onClick: clickHandler }, label));
}
exports.default = Chip;
